import store from '../..';
import router from '../../../router';

export function filter(params) {
  const filters = getFilters();
  return processFilterData(params, filters);
}
export function processFilterData(params, filters) {
  const variables = {};

  for (let i = 0; i < params.length; i++) {
    if (filters[params[i]]) {
      if (params[i] === 'city') {
        variables.address = { city: filters[params[i]] };
      } else {
        variables[params[i]] = typeof filters[params[i]] === 'string'
          ? filters[params[i]].toLowerCase()
          : filters[params[i]];
      }
    }
  }
  return variables;
}
export function getFilters() {
  let filters;
  if (router.history.current.name === 'Reconciliation') {
    const tab = store.getters['reconciliation/getTab'];
    if (tab === 0) {
      filters = store.getters['filters/getFilter'].return;
    } else {
      filters = store.getters['filters/getFilter'].oneWay;
    }
  } else {
    filters = store.getters['filters/getFilter'];
  }
  return filters;
}
